function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useLayoutEffect, useRef, Children } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animated, useSpring } from '@react-spring/web';
var CollapseContainer = styled(animated.div).withConfig({
  displayName: "Collapse__CollapseContainer",
  componentId: "sc-fn6eem-0"
})(["overflow:hidden;height:", ";"], function (_ref) {
  var collapsed = _ref.collapsed;
  return collapsed ? 0 : 'auto';
}); // a hook that listens for a change in isOpened
// and initiates a height animation

var useAnimateHeight = function useAnimateHeight(_ref2) {
  var containerRef = _ref2.containerRef,
      isOpened = _ref2.isOpened;

  var _useSpring = useSpring(function () {
    return {
      height: ''
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      height = _useSpring2[0].height,
      api = _useSpring2[1];

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAtRest = _React$useState2[0],
      setIsAtRest = _React$useState2[1];

  var prevContainerHeights = useRef([]);

  var animateHeight = function animateHeight(_ref3) {
    var prevHeight = _ref3.prevHeight,
        currentHeight = _ref3.currentHeight;
    if (!containerRef.current) return;
    setIsAtRest(false);
    api.start({
      height: prevHeight,
      immediate: true
    });
    api.start({
      height: currentHeight,
      config: {
        tension: 247,
        friction: 31
      },
      immediate: false,
      onRest: function onRest() {
        api.start({
          height: '',
          immediate: true,
          onRest: function onRest() {
            setIsAtRest(true);
          }
        });
      }
    });
  };

  useLayoutEffect(function () {
    if (!containerRef.current) return; // if we're interrupting an animation, just use the previously cached height

    var currentHeight = isAtRest ? containerRef.current.offsetHeight : prevContainerHeights.current[0];
    var isInitialLayout = !prevContainerHeights.current.length;

    if (!isInitialLayout) {
      animateHeight({
        currentHeight: currentHeight,
        prevHeight: prevContainerHeights.current.slice(-1)[0]
      });
    }

    prevContainerHeights.current = prevContainerHeights.current.slice(-1).concat(currentHeight);
  }, [isOpened]); // eslint-disable-line

  return [height, isAtRest];
};

export var Collapse = function Collapse(_ref4) {
  var children = _ref4.children,
      isOpened = _ref4.isOpened,
      style = _ref4.style;
  var containerRef = useRef();

  var _useAnimateHeight = useAnimateHeight({
    containerRef: containerRef,
    isOpened: isOpened
  }),
      _useAnimateHeight2 = _slicedToArray(_useAnimateHeight, 1),
      height = _useAnimateHeight2[0];

  return /*#__PURE__*/React.createElement(CollapseContainer, {
    ref: containerRef,
    collapsed: !isOpened ? 'true' : undefined,
    "aria-hidden": !isOpened,
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: height.to(function (height) {
        return typeof height === 'number' ? "".concat(height, "px") : '';
      })
    })
  }, children);
};
var collapsePropTypes = {
  children: PropTypes.node,
  isOpened: PropTypes.bool
};
Collapse.propTypes = collapsePropTypes;
export var UnmountClosed = function UnmountClosed(_ref5) {
  var children = _ref5.children,
      isOpened = _ref5.isOpened,
      style = _ref5.style;
  var containerRef = useRef();

  var _useAnimateHeight3 = useAnimateHeight({
    containerRef: containerRef,
    isOpened: isOpened
  }),
      _useAnimateHeight4 = _slicedToArray(_useAnimateHeight3, 2),
      height = _useAnimateHeight4[0],
      isAtRest = _useAnimateHeight4[1];

  var collapsedElement = Children.count(children) > 1 ? /*#__PURE__*/React.createElement("div", null, children) : children;
  var renderChildren = !(!isOpened && isAtRest);
  return /*#__PURE__*/React.createElement(CollapseContainer, {
    ref: containerRef,
    collapsed: !isOpened ? 'true' : undefined,
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: height.to(function (height) {
        return typeof height === 'number' ? "".concat(height, "px") : '';
      })
    })
  }, renderChildren && collapsedElement);
};
UnmountClosed.propTypes = collapsePropTypes;